// Heavy libraries that only some pages use are built as separate bundles
// (see esbuild-defaults.config.js) and fetched on first use. The build
// injects LAZY_LIBRARY_URLS, relative to application.js.
//
// They must be resolved to absolute URLs up front: application.js comes from
// the CDN without a crossorigin attribute, and import() in such a script
// resolves relative specifiers against about:blank. document.currentScript is
// only set while application.js first runs, so capture it at module load.
const baseURL = document.currentScript?.src || document.baseURI

export const lazyImport = name => import(new URL(LAZY_LIBRARY_URLS[name], baseURL).href)
